import { useRequest } from "ahooks";
import { API_ENDPOINT } from "@/config/endpoint/endpoint";

export const useFetchLocalPlaces = () => {
  return useRequest(() => API_ENDPOINT.places.getLocalPlaces(), {
    cacheKey: `local-places`,
  });
};